/* tslint:disable */
/* eslint-disable */
/**
 * Pfa API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StarterServicesDto } from './StarterServicesDto';
import {
    StarterServicesDtoFromJSON,
    StarterServicesDtoFromJSONTyped,
    StarterServicesDtoToJSON,
    StarterServicesDtoToJSONTyped,
} from './StarterServicesDto';
import type { StarterExmsDto } from './StarterExmsDto';
import {
    StarterExmsDtoFromJSON,
    StarterExmsDtoFromJSONTyped,
    StarterExmsDtoToJSON,
    StarterExmsDtoToJSONTyped,
} from './StarterExmsDto';

/**
 * 
 * @export
 * @interface StarterDto
 */
export interface StarterDto {
    /**
     * 
     * @type {number}
     * @memberof StarterDto
     */
    showId?: number;
    /**
     * 
     * @type {string}
     * @memberof StarterDto
     */
    bookerId?: string | null;
    /**
     * 
     * @type {number}
     * @memberof StarterDto
     */
    startNo?: number;
    /**
     * 
     * @type {string}
     * @memberof StarterDto
     */
    horseRegisterId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StarterDto
     */
    riderRegisterId?: string | null;
    /**
     * 
     * @type {Array<StarterExmsDto>}
     * @memberof StarterDto
     */
    bookedExams?: Array<StarterExmsDto> | null;
    /**
     * 
     * @type {Array<StarterServicesDto>}
     * @memberof StarterDto
     */
    bookedServices?: Array<StarterServicesDto> | null;
}

/**
 * Check if a given object implements the StarterDto interface.
 */
export function instanceOfStarterDto(value: object): value is StarterDto {
    return true;
}

export function StarterDtoFromJSON(json: any): StarterDto {
    return StarterDtoFromJSONTyped(json, false);
}

export function StarterDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): StarterDto {
    if (json == null) {
        return json;
    }
    return {
        
        'showId': json['showId'] == null ? undefined : json['showId'],
        'bookerId': json['bookerId'] == null ? undefined : json['bookerId'],
        'startNo': json['startNo'] == null ? undefined : json['startNo'],
        'horseRegisterId': json['horseRegisterId'] == null ? undefined : json['horseRegisterId'],
        'riderRegisterId': json['riderRegisterId'] == null ? undefined : json['riderRegisterId'],
        'bookedExams': json['bookedExams'] == null ? undefined : ((json['bookedExams'] as Array<any>).map(StarterExmsDtoFromJSON)),
        'bookedServices': json['bookedServices'] == null ? undefined : ((json['bookedServices'] as Array<any>).map(StarterServicesDtoFromJSON)),
    };
}

export function StarterDtoToJSON(json: any): StarterDto {
    return StarterDtoToJSONTyped(json, false);
}

export function StarterDtoToJSONTyped(value?: StarterDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'showId': value['showId'],
        'bookerId': value['bookerId'],
        'startNo': value['startNo'],
        'horseRegisterId': value['horseRegisterId'],
        'riderRegisterId': value['riderRegisterId'],
        'bookedExams': value['bookedExams'] == null ? undefined : ((value['bookedExams'] as Array<any>).map(StarterExmsDtoToJSON)),
        'bookedServices': value['bookedServices'] == null ? undefined : ((value['bookedServices'] as Array<any>).map(StarterServicesDtoToJSON)),
    };
}

